export const generateRandom32DigitNumber = () => {
  let result = ''
  for (let i = 0; i < 32; i++) {
    result += Math.floor(Math.random() * 10) // Generates a random digit from 0 to 9
  }
  return result
}

export const hashCode = () => {
  return generateRandom32DigitNumber()
}
